<app-roles [roles]="serviceRoles" [isRoot]="false" [determinantMapById]="determinantMapById"
    [institutions]="institutions" [hideList]="true">
    <div class="row mt-4 mb-3">
        <div class="col-12">
            <div id="role-main-tabs" class="row">
                <div class="col-12 d-flex align-items-center">
                    <h2 *ngIf="!role" class="page-title line-height-1">{{'Add role' | translate}}</h2>
                    <span *ngIf="role" class="d-flex w-100 pr-1 title align-items-center">
                        <div class="d-inline-flex ml-0">
                            <ul class="d-flex nav nav-pill nav-tabs styleguide-tabs text-center">
                                <li class="mr-3 nav-item">
                                    <a class="nav-link cursor-pointer" routerLink="{{baseUrl}}" tooltip="{{'Back to list' | translate}}">
                                        <i class="fas fa-angle-left mr-2"></i>
                                        {{'Back to list' | translate}}
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <!--<b>{{ "Detail of the role" | translate }}</b>-->
                    </span>
                </div>
            </div>
        </div>
    </div>

    <div class="role-main-tabs d-flex">
        <div class="role-tab" *ngIf="role?.id && role.name">
            <span class="highlight">{{role.name}}</span>
        </div>
        <div class="role-tab {{activeTab === 'general' ? 'active-tab': ''}}" (click)="notifyTabChange('general')">
            {{ 'roles.generalTab' | translate }}
        </div>
        <div *ngIf="role && role.type === 'UserRole' && role.formSchema"
            class="role-tab {{activeTab === 'form' ? 'active-tab': ''}}"
            (click)="notifyTabChange('form'); reloadRole();">
            {{ 'roles.form' | translate }}
        </div>
        <div *ngIf="role && role.type === 'BotRole'"
            class="role-tab {{activeTab === 'bot-selector' ? 'active-tab': ''}}"
            (click)="notifyTabChange('bot-selector')">
            {{ 'roles.botselector' | translate }}
        </div>
        <div class="role-tab {{activeTab === 'statuses' ? 'active-tab': ''}} d-flex align-items-center"
            (click)="notifyTabChange('statuses')">
            {{ 'roles.statuses' | translate }}
            <span *ngIf="activeTab === 'statuses'" (click)="openAddStatus()" class="addBtn services-icon--add ml-3">{{
                'roles.statusAdd' | translate }}</span>
        </div>
        <div class="align-items-center d-flex ml-auto">
            <business-key *ngIf="role?.businessKey" [businessKey]="role?.businessKey" [tooltipPosition]="'left'"
                [businessKeyTooltip]="'Role business key' | translate" [extraClass]="'ml-2'"> </business-key>
            <tutorial-layer *ngIf="!isLoading && role && role.tutorials && role.tutorials.general"
                class="inpage-tutorial inline-tutorial-button" title="{{ role.name }}" [isClosed]="true"
                [editorData]="role.tutorials.general" (saveTutorial)="saveTutorial($event)">
            </tutorial-layer>
        </div>
    </div>

    <div class="role-main-tabs-content">
        <div class="role-tab-content tab-general {{activeTab === 'general' ? 'active-tab': ''}}">
            <div class="role-tab-inner">
                <div class="row fields-group faded py-2 mb-4">
                    <div class="col">
                        <span class="list-item-field mr-0 ml-0" (click)="toggleStartRole()">
                            <i class="mr-2 fas {{role?.startRole ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"
                                style="position:relative; top:2px"></i>
                            {{'Start role' | translate}}
                        </span>
                        <span *ngIf="role && role.type" class="ml-4">
                            {{ role.type | translate }}
                        </span>
                        <span *ngIf="role && role.assignedTo" class="ml-4">
                            {{'Assigned to' | translate}} {{role.assignedTo | translate}}
                        </span>
                        <span class="ml-4 pull-right toggle-small" (click)="toggleAccessReport()"
                            *ngIf="role?.assignedTo === 'processing' || role?.assignedTo === 'treasury'">
                            <i class="mr-2 fas {{role?.allowAccessToFinancialReports ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"
                                style="position:relative; top:2px"></i>
                            {{'Allow access to financial reports' | translate}}
                        </span>
                        <span class="ml-4 pull-right toggle-small" (click)="toggleAllowToConfirmPayments()"
                            *ngIf="role?.assignedTo === 'processing' || role?.assignedTo === 'treasury'">
                            <i class="mr-2 fas {{role?.allowToConfirmPayments ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"
                                style="position:relative; top:2px"></i>
                            {{'Allow to confirm payments' | translate}}
                        </span>
                    </div>
                </div>
                <role-manage (updatedRole)="reloadRole()" (changeBotType)="changeBotType()"
                    (changeBotCategory)="changeBotCategory()" [serviceId]="serviceId" [role]="role"
                    [determinantMapById]="determinantMapById" [institutions]="institutions"
                    [roleInstitutions]="roleInstitutions" [debugErrors]="debugErrors"
                    (changedData)="updatedRole($event)" (selectInstitution)="setInstitution($event)"
                    *ngIf="role?.id && activeTab === 'general'"></role-manage>
            </div>
        </div>
        <div *ngIf="role && role.type === 'UserRole' && role.formSchema && showFormio"
            class="role-tab-content tab-form {{activeTab === 'form' ? 'active-tab': ''}} {{this.store.state.common.lockedPageByUser ? 'locked-page' : ''}}">
            <div class="page-locker" *ngIf="this.store.state.common.lockedPageByUser"> </div>
            <div class="p-4">
                <div class="row form-main-actions w-100 preview-button-container-sticky mt-0 py-2 align-content-center"
                    *ngIf="serviceId && store.state.common.userLevels.pages && store.state.common.userLevels.pages.SideNavLevel >= 2">
                    <div class="col-sm-12 closer-form">
                        <form-builder-actions *ngIf="activeTab === 'form'" class="ml-auto"
                            [formKey]="'applicant-form-sidebar'" [serviceId]="serviceId" [myFormio]="myFormio"
                            [downloadHandler]="downloadSchema.bind(this)" [historyHandler]="openHistory.bind(this)"
                            [historyLabelKey]="'Form history'" [minUserLevel]="2" [requireService]="false">
                        </form-builder-actions>
                    </div>
                </div>
                <div id="formio-reference">
                    <my-formio *ngIf="activeTab === 'form'" #myFormio [serviceId]="serviceId" [roleId]="roleId"
                        [focusCompKey]="focusCompKey" [pasteWithTransformationEnabled]="true"
                        [determinantMapById]="determinantMapById" [fileLinkableWithRequirement]="isForApplicant()"
                        [fileLinkableWithResult]="!isForApplicant()" [formSchema]="role.formSchema"
                        [formName]="role.camundaName" formType="Role" (saveFormSchema)="saveForm($event)"
                        class="role-detail-builder form-with-preview"></my-formio>
                </div>
            </div>
        </div>
        <div *ngIf="role && role.type === 'BotRole'"
            class="role-tab-content tab-bot-service {{activeTab === 'bot-selector' ? 'active-tab': ''}}">
            <div class="p-tab-container">
                <bot-triggers class="inpage" [contextLabel]="role.name" [roleId]="roleId" [serviceId]="serviceId"
                    [embedded]="false" [determinantMapById]="determinantMapById" [showSystemBots]=false></bot-triggers>
            </div>
        </div>
        <div class="role-tab-content tab-statuses {{activeTab === 'statuses' ? 'active-tab': ''}}">
            <div class="p-tab-container">
                <status-role *ngFor="let status of statuses" [role]="role" [status]="status"
                    (modalOpenedEvent)="openMessagesList($event)" [rejectionReasons]="rejectionReasons"
                    (updateRejectionReason)="updateRejectionReason($event)" (statusUpdated)="reloadRole();"
                    [destinations]="serviceRoles"></status-role>
            </div>
        </div>
    </div>

    <role-determinant
        *ngIf="role && store.state.common.sections.active && store.state.common.sections.type === 'determinant'"
        [role]="role" [serviceId]="serviceId" (editCancel)="closeSection();" [ngStyle]="style" mwlResizable
        [enableGhostResize]="true" [resizeEdges]="resizeEdges" (resizeEnd)="onResizeEnd($event)"
        (update)="updateDeterminant($event)"></role-determinant>

    <determinant-role-institution *ngIf="role && roleInstitution" [roleInstitution]="roleInstitution"
        [serviceId]="serviceId" (editCancel)="closeSection();" [ngStyle]="style" mwlResizable [enableGhostResize]="true"
        [resizeEdges]="resizeEdges" (resizeEnd)="onResizeEnd($event)"
        class="{{store.state.common.sections.active && store.state.common.sections.type === 'institution-determinant' ? '': 'hidden'}}"></determinant-role-institution>

    <institution-edit
        *ngIf="institutions && institutions.length > -1 && roleInstitutions && roleInstitutions.length > -1 && role"
        (editCancel)="closeSection();" (formSubmit)="closeSection();" [ngStyle]="style" mwlResizable
        [enableGhostResize]="true" [roleInstitutions]="roleInstitutions" [institutions]="institutions" [role]="role"
        [resizeEdges]="resizeEdges" (resizeEnd)="onResizeEnd($event)"
        class="{{store.state.common.sections.type === 'institution' ? '': 'hidden'}}">
    </institution-edit>

    <unit-edit *ngIf="roleInstitutions && roleInstitutions?.length && role" (editCancel)="closeSection();"
        (formSubmit)="closeSection();" [ngStyle]="style" mwlResizable [enableGhostResize]="true"
        [roleInstitutions]="roleInstitutions" [role]="role" [resizeEdges]="resizeEdges"
        (resizeEnd)="onResizeEnd($event)" class="{{store.state.common.sections.type === 'unit' ? '': 'hidden'}}">
    </unit-edit>

    <!-- <determinant-new *ngIf="store.state.common.determinantSection.topLayer === 'edit'"
                      class="row layer sub-layer px-3"
                      [serviceId]="serviceId"
                      [determinant]="store.state.common.determinantSection.determinant"
                      (formSubmit)="closeEditDeterminant()"
                      (editCancel)="closeEditDeterminant()"></determinant-new> -->
    <status-message-list *ngIf="showList" (editCancel)="closeSection();" [messageData]="messagedata"
        (selectItem)="openAddStatusAfterSelect($event)" class="row px-3 role-status-messages-list">
    </status-message-list>
    <drawer *ngIf="store.state.common.sections.type === 'statusMessageEdit'" [title]="'Edit message'"
        (saveEvent)="saveStatusMessage()" [isClosed]="false" (closeEvent)="closeSection();" [noContentPadding]="true">
        <status-message-edit class="drawer-content drawer-direct-content px-4 pb-4" [allRoles]="serviceRoles"
            [role]="role" [message]="message" [roleStatusMessage]="roleStatusMessage" [messageType]="messageType"
            [statusType]="statusType" (editCancel)="closeSection();" (editSave)="closeSection();"
            [statusType]="statusType"></status-message-edit>
    </drawer>
    <drawer *ngIf="store.state.common.sections.type === 'messageEdit'" [title]="'Edit message'"
        (saveEvent)="saveEditMessage()" [isClosed]="false" (closeEvent)="closeSection();" [noContentPadding]="true">
        <message-edit class="drawer-content drawer-direct-content px-4 py-4" [serviceId]="serviceId" [message]="message"
            [disableType]="true" (editCancel)="closeSection();" (formSubmit)="reloadRole()"></message-edit>
    </drawer>
    <status-new [role]="role" [destinations]="serviceRoles" [ngStyle]="style" mwlResizable [enableGhostResize]="true"
        [resizeEdges]="resizeEdges" (resizeEnd)="onResizeEnd($event)" (editCancel)="closeSection();"
        class="row layer half-layer px-3 {{store.state.common.sections.active && store.state.common.sections.type === 'status' ? '': 'hidden'}}">
    </status-new>

    <app-history-form *ngIf="showHistory && role" [serviceId]="serviceId" [determinantMapById]="determinantMapById"
        [roleId]="role.id" [historyController]="roleController" (changeForm)="changeForm($event)"
        (closeLayer)="closeHistory()">
    </app-history-form>
    <div class="shadow"></div>
    <div class="row">
        <div class="col-12">
        </div>
    </div>


</app-roles>
<!--content-tbc-->